(function($) {

	'use strict';

	var init = function() {

        moveCursor();
        
        //changeCursor();
        
	};

	var moveCursor = function() {

        var posX = 0;
        var posY = 0;

        //var cursor = false;

        $(document).mousemove(function(e) {
            posX = e.pageX;
            posY = e.pageY;

            // if(cursor == false) {
            //     $('<span id="cursor"></span>').insertAfter('.header');
            //     cursor = true;
            // }
        });

        $(window).on('wheel', function(e) {
            posX = e.pageX;
            posY = e.pageY;
        });

        // setInterval(function() {

        //     if(posY >= $(document).height() - 50) {
        //         posY = $(document).height() - 50;
        //     }
            
        //     //$('#cursor').css('transform', 'translate3d(' + (posX - 50) + 'px, ' + (posY - 50) + 'px, 0)');

        // }, 100);

        $('.blend').each(function(e) {

            var $invert = $(this);

            setInterval(function() {
                var position = $invert.offset();
                var top = position.top;
                var left = position.left;
                $invert.css('--x', (posX - left) + 'px');
                $invert.css('--y', (posY - top) + 'px');
            }, 100);

            $(this).mouseenter(function() {
                $(this).addClass('blend-active');
                //$('#cursor').addClass('blend-active');
            });
            $(this).mouseleave(function() {
                $(this).removeClass('blend-active');
                //$('#cursor').removeClass('blend-active');
            });

        });
        
    }
    
    // var changeCursor = function() {

    //     $('a, button, input, select, textarea, .menu-item-has-children, input[type="checkbox"] ~ label, input[type="radio"] ~ label, .fp-exp__bull, .next-wrapper, .prev-wrapper, .ginput_container_fileupload, .filename__remove, .fp-exp__cover').each(function() {
    //         $(this).mouseenter(function() {
    //             $('#cursor').addClass('active');
    //         });
    //         $(this).mouseleave(function() {
    //             $('#cursor').removeClass('active');
    //         });
    //     });
    //     $('iframe').each(function() {
    //         $(this).mouseenter(function() {
    //             $('#cursor').addClass('hidden');
    //         });
    //         $(this).mouseleave(function() {
    //             $('#cursor').removeClass('hidden');
    //         });
    //     });

    // }

	$(document).ready(function() {
        var isFirefox = !(window.mozInnerScreenX == null);
        if(isFirefox == false) {
		    init();
        }
    });
    // $(document).on('gform_post_render', function() {
    //     var isFirefox = !(window.mozInnerScreenX == null);
    //     if(isFirefox == false) {
	// 	    changeCursor();
    //     }
    // });

})(jQuery);